import Parser from 'html-react-parser';
import { useAEMResource } from "@hooks";

const Footer = () => {
  const { footer, stylesLoaded } = useAEMResource();

  if (!stylesLoaded || !footer) return null;
  return <>{Parser(footer)}</>;
}

export { Footer };
